  import Enum from './enum'

class CurrencyWithTheSame extends Enum
{
  constructor(value) {
    super(value);
  }
}

CurrencyWithTheSame.init({
  EMPTY: 'None',
  BYN: 'BYN',
  RUB: 'RUB',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY',
  THE_SAME: 'Same'
}, {
  EMPTY: 'currency.none',
  BYN: 'currency.byn',
  RUB: 'currency.rub',
  USD: 'currency.usd',
  EUR: 'currency.eur',
  CNY: 'currency.cny',
  THE_SAME: 'form.catalogs.catalog-type.additional-present-price.currency.the-same'
});

export default CurrencyWithTheSame;
